import { render, staticRenderFns } from "./GanttHeader.vue?vue&type=template&id=b6b6e108&scoped=true&lang=pug&"
import script from "./GanttHeader.vue?vue&type=script&lang=js&"
export * from "./GanttHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b6e108",
  null
  
)

export default component.exports